<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <usuario-form
            v-show="isModalVisible"
            @close="closeModal"
            :afterCreateAction="loadList"
            :action="parceiroAction"
            :usuario="parceiro"
            :parceiroDefaultOption="parceiroDefaultOption"
          ></usuario-form>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
    <template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <card
                class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
              >
                <template slot="header">
                  <div class="float-left">
                    <h4 class="card-title">Parceiros Cadastrados</h4>
                  </div>
                  <div class="float-right">
                    <button
                      type="submit"
                      class="btn btn-success btn-fill"
                      @click="novoParceiro"
                    >
                      Novo
                    </button>
                  </div>
                </template>
                <div class="ml-3 mb-4 mt-2">
                  <label for="perfil" class="mb-3">Filtros</label>
                  <div class="d-flex flex-column flex-sm-row">
                    <div
                      class="d-flex mr-0 mr-sm-5 mb-4 mb-sm-0 align-self-center"
                    >
                      <label
                        for="ativo"
                        class="d-flex align-items-center mb-0 pr-2"
                        >Nome</label
                      >
                      <input v-model="filtro.nome" class="form-control" />
                    </div>
                    <div class="d-flex">
                      <button @click="loadList()" class="btn btn-success mr-2">
                        Filtrar
                      </button>
                      <button
                        @click="limparFiltrosEBuscarLista()"
                        class="btn btn-danger mr-2"
                      >
                        Limpar filtros
                      </button>
                    </div>
                  </div>
                </div>
                <l-table
                  class="table-hover table-striped"
                  :columns="tabelaParceiros.columns"
                  :data="tabelaParceiros.data"
                >
                  <template slot-scope="{ row }">
                    <td>
                      <b>{{ row.codigo }}</b>
                    </td>
                    <td>
                      <b>{{
                        row.tipoParceiro === 'pf'
                          ? `${row.nome} ${row.sobrenome}`
                          : row.razaoSocial
                      }}</b>
                    </td>
                    <td>
                      <button
                        class="btn btn-icon btn-info"
                        style="margin-right: 10px"
                        @click="editarParceiro(row)"
                        title="Editar"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <router-link
                        :to="{
                          name: 'ListaProjetosParceiro',
                          params: {
                            codigoParceiro: row.codigo
                          }
                        }"
                      >
                        <button
                          class="btn btn-icon btn-primary"
                          style="margin-right: 10px"
                          title="Projetos"
                        >
                          <i class="fa fa-file-text"></i>
                        </button>
                      </router-link>
                      <router-link
                        :to="{
                          name: 'RelatorioStatusParceiro',
                          params: { codigoParceiro: row.codigo },
                          query: {
                            nomeParceiro:
                              row.tipoParceiro === 'pf'
                                ? `${row.nome} ${row.sobrenome}`
                                : row.razaoSocial
                          }
                        }"
                      >
                        <button
                          class="btn btn-icon"
                          style="margin-right: 10px; color: #000"
                          title="Relatório status por mês"
                        >
                          <i class="fa fa-bar-chart"></i>
                        </button>
                      </router-link>
                    </td>
                  </template>
                </l-table>
                <template slot="footer">
                  <v-pagination
                    v-if="tabelaParceiros.data.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                  ></v-pagination>
                </template>
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- DELETE MODAL -->
    <div v-show="isDeleteModalVisible" @close="closeModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Deseja realmente excluir o parceiro?</strong>
                </h5>
              </div>
              <div class="modal-body">
                Esta ação é definitiva e não poderá ser desfeita.
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click.prevent
                  @click="closeDeleteModal()"
                >
                  Fechar
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click.prevent
                  @click="deletarParceiro()"
                >
                  Deletar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import LTable from 'src/components/Table.vue';
import ParceirosService from 'src/services/parceiros';
import vPagination from 'vue-plain-pagination';
import UsuarioForm from '../Forms/UsuarioForm.vue';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['Código', 'Nome'];

export default {
  components: {
    UsuarioForm,
    LTable,
    vPagination
  },
  data() {
    return {
      parceiroDefaultOption: true,
      tabelaParceiros: {
        columns: [...tableColumns],
        data: []
      },
      isModalVisible: false,
      parceiroAction: '',
      parceiro: {},
      parceiroCode: undefined,
      isDeleteModalVisible: false,
      parceiroParaDeletar: {},
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      },
      filtro: {
        nome: ''
      }
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      ParceirosService.listar({
        page: this.currentPage,
        nome: this.filtro.nome
      })
        .then(response => {
          this.tabelaParceiros.data = _.get(response, 'data.result');
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            icon: 'fa fa-exclamation-triangle'
          });
        });
    },
    maskCep(cep) {
      cep = cep.replace(/\D/g, '');
      cep = cep.replace(/^(\d{2})(\d)/, '$1.$2');
      cep = cep.replace(/\.(\d{3})(\d)/, '.$1-$2');
      return cep;
    },
    maskCpf(cpf) {
      cpf = cpf.replace(/\D/g, '');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      return cpf;
    },
    maskCnpj(cnpj) {
      cnpj = cnpj.replace(/\D/g, '');
      cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2');
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
      cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');
      return cnpj;
    },
    maskPhone(tel) {
      tel = tel.replace(/\D/g, '');
      tel = tel.replace(/^(\d)/, '($1');
      tel = tel.replace(/(.{3})(\d)/, '$1)$2');
      if (tel.length == 9) {
        tel = tel.replace(/(.{1})$/, '-$1');
      } else if (tel.length == 10) {
        tel = tel.replace(/(.{2})$/, '-$1');
      } else if (tel.length == 11) {
        tel = tel.replace(/(.{3})$/, '-$1');
      } else if (tel.length == 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      } else if (tel.length > 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      }
      return tel;
    },
    novoParceiro() {
      this.parceiroAction = 'NEW';
      this.parceiroCode = undefined;
      this.isModalVisible = true;
      this.parceiroDefaultOption = false;
      this.parceiro = {};
    },
    editarParceiro(parceiro) {
      this.parceiroAction = 'EDIT';
      this.parceiroDefaultOption = true;

      if (parceiro.cnpj) {
        parceiro.cnpj = this.maskCnpj(parceiro.cnpj);
      }
      if (parceiro.cpf) {
        parceiro.cpf = this.maskCpf(parceiro.cpf);
      }
      parceiro.cep = this.maskCep(parceiro.cep);
      parceiro.telefone = this.maskPhone(parceiro.telefone);
      this.parceiro = { ...parceiro };
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    handleDelete(row) {
      this.isDeleteModalVisible = true;
      this.parceiroParaDeletar = row;
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.parceiroParaDeletar = {};
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    deletarParceiro() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Deletado com Sucesso.',
          'fa fa-check'
        );
        this.loadList();
        this.closeDeleteModal();
        loader.hide();
      };

      const errorCallback = err => {
        this.notifyVue(
          'top',
          'center',
          'danger',
          err,
          'fa fa-exclamation-triangle'
        );
        this.closeDeleteModal();
        loader.hide();
      };

      ParceirosService.deletar(this.parceiroParaDeletar)
        .then(sucessCallback)
        .catch(errorCallback);
    },
    parseDate(date) {
      const year = date.slice(0, 4);
      const month = date.slice(5, 7);
      const day = date.slice(8, 10);
      return `${day}/${month}/${year}`;
    },
    limparFiltrosEBuscarLista() {
      this.filtro = {
        nome: ''
      };
      this.loadList();
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    }
  }
};
</script>
<style scope>
.pagination {
  justify-content: center;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
}
</style>
